import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field } from "@/components/Forms";
import { DIALOG_CLS } from "@/components/Dialogs";
import { METRICS } from "@/lib/tasks";

const EMPTY = { title: "", collaboratorId: "company", metric: "tarefas", target: "", unit: "%", current: 0 };

function GoalForm({ initial, people, onSave }) {
  const [f, setF] = useState(initial ? { ...initial, collaboratorId: initial.collaboratorId || "company" } : EMPTY);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v?.target ? v.target.value : v }));
  const manual = f.metric === "manual";
  const submit = (e) => {
    e.preventDefault();
    if (!f.title.trim()) return toast.error("Dê um nome para a meta.");
    if (!(Number(f.target) > 0)) return toast.error("Informe um alvo válido.");
    onSave({ ...f, title: f.title.trim(), target: Number(f.target), current: Number(f.current) || 0, unit: manual ? f.unit || "un" : "%", collaboratorId: f.collaboratorId === "company" ? null : f.collaboratorId });
  };
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="goal-form">
      <Field label="Meta"><Input value={f.title} onChange={set("title")} placeholder="Ex.: Checklists completos" data-testid="goal-title-input" /></Field>
      <Field label="Aplica-se a">
        <Select value={f.collaboratorId} onValueChange={set("collaboratorId")}><SelectTrigger data-testid="goal-scope-select"><SelectValue /></SelectTrigger><SelectContent><SelectItem value="company">Empresa (toda a equipe)</SelectItem>{people.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent></Select>
      </Field>
      <Field label="Como medir">
        <Select value={f.metric} onValueChange={set("metric")}><SelectTrigger data-testid="goal-metric-select"><SelectValue /></SelectTrigger><SelectContent>{Object.entries(METRICS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select>
      </Field>
      <div className="grid grid-cols-2 gap-4">
        <Field label={manual ? "Alvo" : "Alvo (%)"}><Input type="number" min="0" value={f.target} onChange={set("target")} data-testid="goal-target-input" /></Field>
        {manual && <Field label="Unidade"><Input value={f.unit === "%" ? "" : f.unit} onChange={set("unit")} placeholder="Ex.: avaliações" data-testid="goal-unit-input" /></Field>}
      </div>
      {manual && <Field label="Resultado atual"><Input type="number" min="0" value={f.current} onChange={set("current")} data-testid="goal-current-input" /></Field>}
      <Button type="submit" className="w-full font-semibold" data-testid="goal-save-button">Salvar meta</Button>
    </form>
  );
}

export function GoalDialog({ open, onOpenChange, initial, people, onSave }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={DIALOG_CLS} data-testid="goal-dialog">
        <DialogHeader><DialogTitle className="font-display text-xl">{initial ? "Editar meta operacional" : "Nova meta operacional"}</DialogTitle></DialogHeader>
        {open && <GoalForm initial={initial} people={people} onSave={onSave} />}
      </DialogContent>
    </Dialog>
  );
}

export function ValueDialog({ open, onOpenChange, title, label, initial, onSave, testId }) {
  const [v, setV] = useState(initial);
  useEffect(() => { if (open) setV(initial ?? ""); }, [open, initial]);
  const submit = (e) => {
    e.preventDefault();
    if (!(Number(v) > 0)) return toast.error("Informe um valor válido.");
    onSave(Number(v));
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (o) setV(initial); onOpenChange(o); }}>
      <DialogContent className={DIALOG_CLS} data-testid={testId}>
        <DialogHeader><DialogTitle className="font-display text-xl">{title}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label={label}><Input type="number" min="0" value={v} onChange={(e) => setV(e.target.value)} data-testid={`${testId}-input`} /></Field>
          <Button type="submit" className="w-full font-semibold" data-testid={`${testId}-save`}>Salvar</Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
